import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const PageWrapper = ({ children, title }) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '60px 105px',
            backgroundColor: 'grey.100',
            minHeight: theme => `calc(100% - ${theme.constants.footerHeight}px)`,
            '@media (max-width: 960px)': {
                padding: '30px',
            },
        }}
    >
        {!!title && (
            <Typography
                sx={{ mb: '60px', '@media (max-width: 960px)': { fontSize: '30px' } }}
                variant="h2"
                align="center"
            >
                {title}
            </Typography>
        )}
        {children}
    </Box>
);

PageWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.node,
};

export default PageWrapper;
